const rePlaceholder = /\{(\d|\d\d)\}/g,
    reIndex = /\d+/;

/**
 * Replace one ore more indexed placeholders in a string with the string representation of specified objects.
 * @example
 * // returns "foo bar"
 * epFormat("foo {0}", "bar")
 * @param format Format string containing indexed placeholders to be replaced.
 * Placeholder index must be in a range 0-99.
 * @param args An array containing zero or more objects to format.
 * @returns A copy of the format string with placeholders replaced by the string representation of the args.
 */
export const epFormat = (format: string, ...args: any[]) =>
    format.replace(rePlaceholder, placeholder => {
        const idx = +reIndex.exec(placeholder)[0];
        return args[idx] !== undefined ? args[idx] : placeholder;
    });
